<template>
  <div class="right-board">
    <el-tabs v-model="currentTab" class="center-tabs">
      <el-tab-pane label="布局属性" name="layout" />
      <el-tab-pane label="组件属性" name="field" />
      <!-- <el-tab-pane label="数据源" name="dataSource" /> -->
    </el-tabs>
    <div class="field-box">
      <el-scrollbar class="right-scrollbar">
        <!-- 布局属性 -->
        <el-form v-show="currentTab === 'layout'" size="small" label-width="90px">
          <div v-for="(item, key) in styleObj" :key="key">
            <p class="tit">{{ key }}</p>
            <el-form-item v-for="(val, key2) in item" :key="key2" :label="key2 + ':'">
              <el-input v-model="styleObj[key][key2]" placeholder="" size="normal" clearable></el-input>
            </el-form-item>
          </div>
        </el-form>

        <!-- 组件属性 -->
        <el-form v-show="currentTab === 'field'" size="small" label-width="90px">
          <el-form-item v-for="(item, key) in activeData" :key="key" :label="labelObj[key] + ':'">
            <el-select v-if="key === 'type'" v-model="activeData[key]" placeholder="" clearable filterable>
              <el-option label="SQL" :value="1"> </el-option>
              <el-option label="API" :value="2"> </el-option>
            </el-select>
            <el-select
              v-else-if="key === 'viewId' && activeData['type'] === 1"
              v-model="activeData[key]"
              placeholder=""
              clearable
              filterable
            >
              <el-option v-for="(item, i) in viewArr" :key="i" :label="item.name" :value="item.id"> </el-option>
            </el-select>
            <el-input v-if="key !== 'type' && key !== 'viewId'" v-model="activeData[key]" placeholder="" size="normal" clearable></el-input>
          </el-form-item>
        </el-form>

        <!-- <el-form v-show="currentTab === 'dataSource'" size="small" label-width="90px">
          <el-form-item v-for="(item, key) in activeData" :key="key" :label="key + ':'">
            <el-select v-if="key === 'type'" v-model="activeData[key]" placeholder="" clearable filterable>
              <el-option label="模块1 -- 描述列表" :value="1"> </el-option>
              <el-option label="模块2 -- 基础列表" :value="2"> </el-option>
            </el-select>
            <el-select v-else-if="key === 'viewId'" v-model="activeData[key]" placeholder="" clearable filterable>
              <el-option v-for="(item, i) in viewArr" :key="i" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </el-form> -->
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    styleObj: Object,
    activeData: Object,
    dataSourceObj: Object
  },
  data() {
    return {
      currentTab: "field",
      viewArr: [],
      labelObj: {
        id: "ID",
        tag: "组件",
        label: "组件名称",
        width: "宽度",
        height: "高度",
        color: "颜色1",
        color2: "颜色2",
        type: "数据源类型",
        viewId: "数据源"
      }
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getChartsViewList();
  },
  methods: {
    async getChartsViewList() {
      const { data } = await this.$api.getChartsViewList();
      this.viewArr = data;
    }
  }
};
</script>

<style lang="scss" scoped>
.right-board {
  width: 350px;
  position: absolute;
  right: 0;
  top: 200px;
  padding: 0 10px;
  padding-top: 3px;
  background-color: #fff;
  border-left: 1px solid #ccc;
  .field-box {
    position: relative;
    height: calc(100vh - 242px);
    box-sizing: border-box;
    overflow: hidden;
  }
  .el-scrollbar {
    height: 100%;
  }
}

.tit {
  font-size: 20px;
}
.select-item {
  display: flex;
  border: 1px dashed #fff;
  box-sizing: border-box;
  & .close-btn {
    cursor: pointer;
    color: #f56c6c;
  }
  & .el-input + .el-input {
    margin-left: 4px;
  }
}
.select-item + .select-item {
  margin-top: 4px;
}
.select-item.sortable-chosen {
  border: 1px dashed #409eff;
}
.select-line-icon {
  line-height: 32px;
  font-size: 22px;
  padding: 0 4px;
  color: #777;
}
.option-drag {
  cursor: move;
}
.time-range {
  .el-date-editor {
    width: 227px;
  }
  ::v-deep .el-icon-time {
    display: none;
  }
}
.document-link {
  position: absolute;
  display: block;
  width: 26px;
  height: 26px;
  top: 0;
  left: 0;
  cursor: pointer;
  background: #409eff;
  z-index: 1;
  border-radius: 0 0 6px 0;
  text-align: center;
  line-height: 26px;
  color: #fff;
  font-size: 18px;
}
.node-label {
  font-size: 14px;
}
.node-icon {
  color: #bebfc3;
}
</style>
